import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, share, tap } from 'rxjs/operators';
import { GlobalService } from 'src/app/services/index.service';
import { ISingleLikertQuestion, SingleMultipleCriteria, ISingleSortingQuestion, ISingleMultiOptionQuestion, IQuestionListSetting } from 'src/app/shared/interfaces/index.interface';

interface IAnswer{
  id:number;
  answer:number[];
  valid:boolean;
  isUnknown:boolean;
}

@Component({
  selector: 'app-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.scss'],
})

export class QuestionListComponent implements OnInit {
  @Input()questionList:(ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion)[] = []
  @Input()quiz:SingleMultipleCriteria = <SingleMultipleCriteria>{}
  @Input()setting:IQuestionListSetting = <IQuestionListSetting>{}
  @Input()nextPageObs$:Observable<boolean> = new Observable<boolean>
  @Input()answers:IAnswer[] = []
  @Output()emitQuestionsData:EventEmitter<IAnswer[]> = new EventEmitter()
  @Output() emitSingleAnswer:EventEmitter<IAnswer> = new EventEmitter()
  pageNumber:number = 0;
  config:any;
  questions:any[] = []
  responseCounter:number = 0;
  answer:IAnswer[] = []
  checkQuestionsValidation:boolean = false;

  constructor(
    private globalService:GlobalService,
  ) { }
  ngOnInit(): void {
    this.config = {...this.quiz.quizdisplaysetting, ...this.quiz.quizlimitationsetting, ...this.quiz.quizquestionsetting, quizUserName: this.quiz.username, isRealTime: this.setting.isRealTime}
    this.nextPageObs$.pipe(
      map(i=>this.checkQuestionsValidation = i)
    ).subscribe()
  }
  isQuestionRequired(id:number){
    let index:number = this.questionList.findIndex(question=> question.id==id)
    if(index>-1)
      return this.questionList[index].is_answer_required
    else
      return null
  }
  scrollToNextQuestion(id:number){
    let i:number = this.questionList.findIndex(q=>q.id==id)
    if(i>-1&&i<this.questionList.length-1)
      this.globalService.scrollToTopOfView('question-'+this.questionList[i+1].id, 110)
  }
  getQuestionData(e:IAnswer){
    if(this.setting.isRealTime){
      this.emitSingleAnswer.emit(e)
      return
    }
    this.responseCounter++;
    if(this.answer.filter(element=>element.id==e.id).length){
      this.answer[this.answer.findIndex(element=>element.id==e.id)] = e
    }else{
      this.answer.push(e)
    }
    if(this.responseCounter%this.questionList.length==0){
      if(this.answer.filter(element=>element.valid==false&&this.isQuestionRequired(element.id)).length<=0 || !this.checkQuestionsValidation){
        this.emitQuestionsData.emit(this.answer)
        this.globalService.scrollToTopOfView('parent', 90)
      }else{
        let errorElement:any = null
        this.answer.map(a=>{
          if(!a.valid && !errorElement && this.isQuestionRequired(a.id))
            if(!errorElement || (errorElement && a.id<errorElement.id))
              errorElement = a
        })
        this.responseCounter = 0;
        this.globalService.scrollToTopOfView('question-'+errorElement.id, 110)
      }
    }
    // if(this.answer.length==this.questionList.length || true)
  }
  getQuestionNumber(index:number){
    return this.quiz.quizdisplaysetting&&this.quiz.quizdisplaysetting.is_show_question_number?this.setting.firstQuestionNumber+index:0;
  }
  convertToLikertQuestion(question:ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion):ISingleLikertQuestion{
    return question as ISingleLikertQuestion
  }
  convertToSortingQuestion(question:ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion):ISingleSortingQuestion{
    return question as ISingleSortingQuestion
  }
  convertToMultiOptionQuestion(question:ISingleLikertQuestion|ISingleSortingQuestion|ISingleMultiOptionQuestion):ISingleMultiOptionQuestion{
    return question as ISingleMultiOptionQuestion
  }
}
